import { useEffect, useState } from "react";
import QuestionSection from "./QuestionSection";
import ArrowLeftIcon from "assets/icons/ArrowLeftIcon";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";

export default function CourseSection({ selectedCourse, setSelectedCourse }) {
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);
  const { language, dir } = useAppSelector(getSettings);
  const [solveQuestion, setSolveQuestion] = useState(false);
  const [oldSelectedCourse, setOldSelectedCourse] = useState({});

  useEffect(() => {
    if (selectedCourse?._id !== oldSelectedCourse?._id) {
      setSolveQuestion(false);
      setOldSelectedCourse(selectedCourse);
    }
  }, [selectedCourse, oldSelectedCourse]);

  if (!selectedCourse?._id) return null;
  return (
    <>
      <div dir={dir}>
        <div className="bg-transparent lg:bg-theme-blue rounded-tl-[27px] rounded-tr-[27px] flex items-center gap-4 pt-6 pb-5 px-10">
          <div
            className="cursor-pointer block lg:hidden"
            onClick={() => {
              setSelectedCourse({});
              if (!isDesktop) {
                document.body.style.overflow = "auto";
              }
            }}
          >
            <ArrowLeftIcon PathClassName={`fill-theme-purple lg:fill-white`} className={language === 'he' ? "rotate-180" : ""}/>
          </div>
          <h2 className="text-theme-purple lg:text-white font-medium text-lg  capitalize">
            {selectedCourse?.title?.[language] || "AUTOMATION"}
          </h2>
        </div>
        <div className="border border-theme-gray pb-10 px-10 rounded-bl-[27px] rounded-br-[27px]">
          <div className="flex justify-between items-center py-7">
            <h4
              className={`${
                solveQuestion ? "" : "underline"
              } text-theme-blue font-semibold text-lg`}
            >
              {t("courseInfoText")}
            </h4>
            <h4
              className={`text-theme-yellow font-medium text-base ${
                solveQuestion ? "underline" : ""
              }`}
            >
              {t("courseSolveText")}
            </h4>
          </div>
          {solveQuestion ? (
            <QuestionSection selectedCourse={selectedCourse} />
          ) : (
            <div>
              <h6 className="font-medium">
                {t("welcomeToThe")}
                {selectedCourse?.title?.[language]}!
              </h6>
              <p className="mt-4 text-base">
                {selectedCourse?.description?.[language]}
              </p>
              <p className="mt-4 text-base">
                {
                  {
                    en: "Your performance will be assessed and you will receive a feedback. While these exercises represent a basic understanding, be sure to acquire the necessary materials listed in the syllabus, and learning process is well based. Together, we will learn, grow, and succeed.",
                    he: "הביצועים שלך יוערכו ותקבל משוב. בעוד שתרגילים אלו מייצגים הבנה בסיסית, הקפידו לרכוש את החומרים הדרושים המפורטים בסילבוס, ותהליך הלמידה מבוסס היטב. ביחד נלמד, נצמח ונצליח.",
                  }[language]
                }
              </p>
              <button
                className="text-lg font-medium text-white bg-theme-yellow rounded-2xl py-3 px-12 mt-5"
                onClick={() => setSolveQuestion(true)}
              >
                {t("courseSolveText")}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
